import React, { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import Projects from '../pages/Projects';
import ProjectForm from '../pages/ProjectForm';
import Categories from '../pages/Categories';
import CategoryForm from '../pages/CategoryForm';
import Inquiries from '../pages/Inquiries';
import ThemeSettings from '../pages/ThemeSettings';
import Careers from '../pages/Careers';
import '../App.css';


const AdminRoutes = () => {

    // const navigate = useNavigate();
    // const role = localStorage.getItem('role');

    // useEffect(() => {
    //     if (role !== 'admin') {
    //         navigate('/')
    //     }
    // }, [role])

    return (
        <Routes>
            <Route element={<AdminLayout />}>
                <Route index element={<Navigate to="projects" replace />} />
                <Route path="projects" element={<Projects />} />
                <Route path="projects/new" element={<ProjectForm />} />
                <Route path="projects/edit/:id" element={<ProjectForm />} />
                <Route path="categories" element={<Categories />} />
                <Route path="categories/new" element={<CategoryForm />} />
                <Route path="categories/edit/:id" element={<CategoryForm />} />
                <Route path="inquiries" element={<Inquiries />} /> {/* Added route for Inquiries */}
                <Route path="theme" element={<ThemeSettings />} />
                <Route path="careers" element={<Careers />} /> {/* Added route for Inquiries */}
                <Route path="*" element={<Navigate to="projects" replace />} />
            </Route>
        </Routes>
    );
}

export default AdminRoutes;